import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Card, Col, Row, Form, Button, Typography, Collapse, Space, Dropdown, MenuProps, Flex, notification, Modal, Input, Select, Segmented } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import RoutingTabs from "./routingTabs";
const { Text, Title } = Typography;
import { DashboardOutlined, DeleteOutlined, DownOutlined, EditOutlined, MinusOutlined, MoreOutlined, OrderedListOutlined, PlusOutlined, UpOutlined, UserOutlined } from "@ant-design/icons";
import './routingMap.scss'
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { postData, putData } from "../../../actions/developer";
import { useAntIcons } from "../../../hooks/useIcons";
import RouteEdit from "./RouteEdit";
import { deleteRow, getData } from "../../../actions/apiCall";

interface ItemRecord {
  status?: string;
  _id?: string;
  name: string;
  parentMenu?: string;
  createdAt?: string;
  updatedAt?: string;
  subparentMenu?: string;
  routeUrl?: string;
  componentName?: string;
  icon?: string;
  order: number;
  subMenu?: string;
  mainMenuRef?: any;
  subMenuRef?: any;
  parentMenuRef?: any;
  newTab?: any;
  list?: ItemRecord[];
}

const Routing: React.FC = () => {
  const dispatch = useDispatch();
  const [mainMenueCollapse, setMainMenueCollapse] = React.useState<{ [key: number]: boolean }>({});
  const [subMenueCollapse, setSubMenueCollapse] = React.useState<{ [key: number]: boolean }>({});
  const [respRoutes, setRespRoutes] = React.useState<ItemRecord[]>([]);
  const [open, setOpen] = React.useState(false);
  const [editItem, setEditItem] = React.useState<ItemRecord | null>(null);
  const { getIcon, iconNames } = useAntIcons();
  const [selectedItem, setSelectedItem] = React.useState<ItemRecord | null>(null)

  useEffect(() => {
    getRoutings();
  }, [])

  const getRoutings = () => {
    dispatch(getData('/routing')).then((res) => {
      if (res) {
        setRespRoutes(res.data.sort((a, b) => a.order - b.order));
      }
    })
  }

  const deleteMenu = async (data) => {
    const resData = await dispatch(postData(`/routing/delete`, data));
    if (resData.code == 200) {
      getRoutings();
    } else {
      notification.error({ message: 'Error', description: resData.message });
    }
  }

  const updateMenu = async (id, data, type) => {
    const resData = await dispatch(putData(`/routing/update/${id}/${type}`, data));
    if (resData) {
      getRoutings();
    } else {
      notification.error({ message: 'Error', description: resData.message });
    }
  }

  const onAddTab = async (routingItems) => {
    const resData = await dispatch(postData(`/routing/routes`, { ...routingItems }));
    if (resData.code == 200) {
      console.log(resData.data);
      getRoutings();
    } else {
      notification.error({ message: 'Error', description: resData.message });
    }
  }

  const getMenu = (item: ItemRecord) => {
    let value = {
      _id: item._id,
      parentMenuRef: item?.parentMenuRef?._id,
      order: item.order
    }
    if (item?.parentMenu) return { ...value, parentMenu: item?.parentMenu };
    if (item?.subMenu) return { ...value, subMenu: item?.subMenu };
    return { ...value, name: item?.name };
  }

  const onDragEnd = (result: any) => {
    const { source, destination } = result;
    if (!destination) return;

    if (source.droppableId === "main-list" && destination.droppableId === "main-list") {
      const reordered = Array.from(respRoutes);
      const [moved] = reordered.splice(source.index, 1);
      reordered.splice(destination.index, 0, moved);
      reordered.forEach((item, index) => {
        item.order = index + 1;
      })
      setRespRoutes(reordered);
      onSave(reordered)
    } else if (source.droppableId.includes("sublist-") && destination.droppableId.includes("sublist-")) {
      const sourceParentIndex = respRoutes.findIndex((item) => `sublist-${item._id}` === source.droppableId);
      const destParentIndex = respRoutes.findIndex((item) => `sublist-${item._id}` === destination.droppableId);

      if (sourceParentIndex !== -1 && destParentIndex !== -1) {
        const sourceSubItems = Array.from(respRoutes[sourceParentIndex].list || []);
        const destSubItems = Array.from(respRoutes[destParentIndex].list || []);
        const [movedSubItem] = sourceSubItems.splice(source.index, 1);

        if (sourceParentIndex === destParentIndex) {
          sourceSubItems.splice(destination.index, 0, movedSubItem);
          const updatedItems = Array.from(respRoutes);
          updatedItems[sourceParentIndex].list = sourceSubItems;
          updatedItems[sourceParentIndex].list.forEach((item, index) => {
            item.order = index + 1;
          })

          setRespRoutes(updatedItems);
          onSave(updatedItems)
        } else {
          destSubItems.splice(destination.index, 0, movedSubItem);
          const updatedItems = Array.from(respRoutes);
          const mainMenuRef = updatedItems[destParentIndex].list[0].mainMenuRef
          updatedItems[sourceParentIndex].list = sourceSubItems;
          updatedItems[destParentIndex].list = destSubItems;
          updatedItems[destParentIndex].list.forEach((item, index) => {
            item.order = index + 1;
            item.mainMenuRef = mainMenuRef;
            item.parentMenuRef = item?.parentMenuRef ? mainMenuRef?._id : undefined
          })
          setRespRoutes(updatedItems);
          onSave(updatedItems)
        }
      }
    } else if (source.droppableId.includes("sub-sub-") && destination.droppableId.includes("sub-sub-")) {
      const sourceParentIndex = respRoutes.findIndex((item) =>
        item.list?.some((subItem) => `sub-sub-${subItem._id}` === source.droppableId)
      );
      const destParentIndex = respRoutes.findIndex((item) =>
        item.list?.some((subItem) => `sub-sub-${subItem._id}` === destination.droppableId)
      );

      if (sourceParentIndex !== -1 && destParentIndex !== -1) {
        const sourceParent = respRoutes[sourceParentIndex];
        const destParent = respRoutes[destParentIndex];

        const sourceSubIndex = sourceParent.list.findIndex(
          (subItem) => `sub-sub-${subItem._id}` === source.droppableId
        );
        const destSubIndex = destParent.list.findIndex(
          (subItem) => `sub-sub-${subItem._id}` === destination.droppableId
        );

        if (sourceSubIndex !== -1 && destSubIndex !== -1) {
          const sourceSubSubItems = Array.from(sourceParent.list[sourceSubIndex].list || []);
          const destSubSubItems = Array.from(destParent.list[destSubIndex].list || []);
          const [movedSubSubItem] = sourceSubSubItems.splice(source.index, 1);

          if (sourceParentIndex === destParentIndex && sourceSubIndex === destSubIndex) {
            // Reorder within the same sub-sub-list
            sourceSubSubItems.splice(destination.index, 0, movedSubSubItem);
            const updatedItems = Array.from(respRoutes);
            updatedItems[sourceParentIndex].list[sourceSubIndex].list = sourceSubSubItems;
            updatedItems[sourceParentIndex].list[sourceSubIndex].list.forEach((item, index) => {
              item.order = index + 1;
            })
            setRespRoutes(updatedItems);
            onSave(updatedItems)
          } else {
            destSubSubItems.splice(destination.index, 0, movedSubSubItem);
            const updatedItems = Array.from(respRoutes);
            updatedItems[sourceParentIndex].list[sourceSubIndex].list = sourceSubSubItems;
            const mainMenuRef = updatedItems[destParentIndex].list[destSubIndex].list[0].mainMenuRef
            const subMenuRef = updatedItems[destParentIndex].list[destSubIndex].list[0].subMenuRef
            updatedItems[destParentIndex].list[destSubIndex].list = destSubSubItems;
            updatedItems[destParentIndex].list[destSubIndex].list.forEach((item, index) => {
              item.order = index + 1;
              item.parentMenu = 'Updated'
              item.mainMenuRef = mainMenuRef;
              item.subMenuRef = subMenuRef;
            })
            setRespRoutes(updatedItems);
            onSave(updatedItems)
          }
        }
      }
    }
  };

  const IconDropDown: MenuProps['items'] = iconNames.map(ele => ({
    key: ele,
    icon: getIcon({ name: ele }),
    label: ele
  }))

  const itemsDropDown = (item: ItemRecord, index: number, parentIndex = null, subParentIndex = null): MenuProps['items'] => {
    let itemList = [
      {
        key: '2',
        icon: <PlusOutlined />,
        label: 'Main Menu',
      },
      {
        key: '3',
        icon: <PlusOutlined />,
        label: 'Sub Menu',
      },
      {
        key: '5',
        icon: <EditOutlined />,
        label: 'Main Menu',
      },
      {
        key: '4',
        icon: <DeleteOutlined />,
        label: 'Main Menu',
      }
    ]

    if (subParentIndex !== null) {
      itemList = itemList.filter(ele => ele.key !== '3')
    }
    if (item.list?.length) {
      itemList = itemList.filter(ele => ele.key !== '5')
    }

    return itemList
  };

  const addItem = (index: number, parentIndex = null, subParentIndex = null) => {
    const newItem: ItemRecord = { name: Date.now().toString(), order: index + 1 };
    const updatedItems = Array.from(respRoutes);
    if (parentIndex === null) {
      onAddTab(newItem);
    } else if (parentIndex !== -1 && subParentIndex === null) {
      const mainMenuRef = getMenu(updatedItems[parentIndex])
      onAddTab({ ...newItem, mainMenuRef });
    } else if (parentIndex !== -1 && subParentIndex !== null) {
      const mainMenuRef = getMenu(updatedItems[parentIndex])
      const subMenuRef = getMenu(updatedItems[parentIndex].list[subParentIndex])
      onAddTab({ ...newItem, mainMenuRef, subMenuRef });
    }
  }

  const addSubItem = (postion: number, currentIndex: number, parentIndex = null, subParentIndex = null) => {
    const newItem: ItemRecord = { name: Date.now().toString(), order: postion + 1 };
    const updatedItems = Array.from(respRoutes);
    if (parentIndex === null) {
      const mainMenuRef = getMenu(updatedItems[currentIndex])
      newItem['mainMenuRef'] = mainMenuRef._id
      onAddTab(newItem);
    } else if (parentIndex !== null && subParentIndex === null) {
      const mainMenuRef = getMenu(updatedItems[parentIndex])
      const subMenuRef = getMenu(updatedItems[parentIndex].list[currentIndex])
      onAddTab({ ...newItem, mainMenuRef, subMenuRef });
    }
  };

  const removeItem = (item: ItemRecord) => {
    if (item.parentMenu) {
      const subMenuIds = (item) => item.list?.filter(ele => ele.subMenu).map((subItem) => subItem._id)
      const listItemId = (item) => item.list?.filter(ele => !ele.subMenu).map((subItem) => subItem._id)
      const subMenuItemIds = (item) => item.list?.filter(ele => ele.subMenu).map((subItem) => subItem.list).flat().map((subSubItem) => subSubItem._id)
      const mainMnueId = [item._id]
      deleteMenu({ mainMnueId, subMenuIds: subMenuIds(item), listItemId: [...listItemId(item), ...subMenuItemIds(item)] })
    } else if (item.subMenu) {
      const subMenuItemIds = (item) => item.list?.map((subItem) => subItem._id)
      const subMenuId = item._id
      deleteMenu({ subMenuIds: [subMenuId], listItemId: subMenuItemIds(item) })
    } else {
      const mainMenuId = item._id
      deleteMenu({ listItemId: [mainMenuId] })
    }
  }

  const mainMenuCollaps = (index: number) => {
    setMainMenueCollapse(prev => ({ ...prev, [index]: !prev[index] }))
  }

  const onSubMenuCollapse = (index: number) => {
    setSubMenueCollapse(prev => ({ ...prev, [index]: !prev[index] }))
  }

  const onSave = async (tempData) => {
    const resData = await dispatch(postData('/routing/update-routes', tempData));
    if (resData) {
      getRoutings();
    }
  }

  const onEdit = (item: ItemRecord) => {
    setOpen(true);
    setEditItem(item);
  }

  const updateRoutes = (type, menu, value) => {
    const updateItem = (item) => {
      if (type === 'icon') {
        return { ...item, icon: value.key };
      } else if (type === 'text') {
        if (item?.parentMenu) return { ...item, parentMenu: value };
        if (item?.subMenu) return { ...item, subMenu: value };
        return { ...item, name: value };
      }
      return item;
    };
    const getRecordType = (item) => {
      if (item?.parentMenu) return 'parent-menu';
      if (item?.subMenu) return 'sub-menu';
      return 'main-menu';
    }
    updateMenu(menu._id, updateItem(menu), getRecordType(menu));
  };

  const onActionMenu = (item, key, index, parentIndex = null, childIndex = null) => {
    console.log('onActionMenu', item, key, index, parentIndex, childIndex)
    switch (key.key) {
      case '2':
        addItem(index + 1, parentIndex, childIndex);
        break;
      case '3':
        addSubItem(0, index, parentIndex, childIndex);
        break;
      case '4':
        removeItem(item);
        break;
      case '5':
        onEdit(item);
        break;
      default:
        break;
    }
  }

  const DropDownView = (item, index, parentIndex = null, subParentIndex = null) => {
    return <Dropdown menu={{ items: itemsDropDown(item, index, parentIndex, subParentIndex), onClick: (e) => onActionMenu(item, e, index, parentIndex, subParentIndex) }}>
      <Button type="text" icon={<MoreOutlined />} />
    </Dropdown >
  }

  const listHeading = (name, item, index, parentId = null, childId = null) => {
    return <Space style={{ width: '100%' }} direction="horizontal">
      <Dropdown menu={{ items: IconDropDown, onClick: (key) => updateRoutes('icon', item, key) }}>
        <Button type="text" icon={getIcon({ name: name ?? 'HomeOutlined' })} />
      </Dropdown >
      <Text editable={{ triggerType: ['text'], onChange: (e) => updateRoutes('text', item, e) }} style={{ width: '100%' }} title={item.name ?? item?.parentMenu ?? item?.subMenu} >
        {item.name ?? item?.parentMenu ?? item?.subMenu}
      </Text>
    </Space >
  }

  return (
    <Row gutter={16}>
      <RouteEdit editItem={editItem} open={open} onClose={() => setOpen(false)} />
      <Col span={6} className="main_menu">
        <Card title={<Flex justify="space-between">
          <Title level={5}>Menu List</Title>
        </Flex>}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="main-list" type="PARENT">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {respRoutes.map((item, index) => (
                    <Draggable key={item._id} draggableId={item._id} index={index}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          style={{
                            ...provided.draggableProps.style,
                          }}
                        >
                          <div
                            {...provided.dragHandleProps}
                            className={selectedItem?._id == item._id ? "draggable-item active-item-class" : "draggable-item"}
                          >
                            <div
                              style={{ display: "flex", justifyContent: "space-between" }}
                              onClick={() => {
                                if (!item?.list || item?.list?.length == 0) {
                                  setSelectedItem(item)
                                }
                              }}>
                              {listHeading(item?.icon, item, index)}
                              <Space>
                                {DropDownView(item, index)}
                                {item?.list?.length && <>
                                  {!mainMenueCollapse[index] && <Button type="text" onClick={() => mainMenuCollaps(index)} size="small" icon={<DownOutlined />} />}
                                  {mainMenueCollapse[index] && <Button type="text" onClick={() => mainMenuCollaps(index)} size="small" icon={<UpOutlined />} />}
                                </>}
                              </Space>
                            </div>
                          </div>
                          {mainMenueCollapse[index] && <Droppable droppableId={`sublist-${item._id}`} type="CHILD">
                            {(subProvided) => (
                              <div
                                ref={subProvided.innerRef}
                                {...subProvided.droppableProps}
                              >
                                {item.list?.map((subItem, subIndex) => (
                                  <Draggable key={subItem._id} draggableId={subItem._id} index={subIndex}>
                                    {(subProvided) => (
                                      <div
                                        ref={subProvided.innerRef}
                                        {...subProvided.draggableProps}

                                        style={{
                                          ...subProvided.draggableProps.style,
                                        }}
                                      >
                                        <div
                                          className={selectedItem?._id == subItem._id ? "draggable-item padding-left-20 active-item-class" : "draggable-item padding-left-20"}
                                          {...subProvided.dragHandleProps}
                                          style={{ display: "flex", justifyContent: "space-between" }}
                                        >
                                          <div
                                            style={{ display: "flex", justifyContent: "space-between", width: '100%' }}
                                            onClick={() => {
                                              if (!subItem?.list || subItem?.list?.length == 0) {
                                                setSelectedItem(subItem)
                                              }
                                            }}>
                                            {listHeading(subItem?.icon, subItem, subIndex, index)}
                                            <Space>
                                              {DropDownView(subItem, subIndex, index)}
                                              {subItem?.list?.length && <>
                                                {!subMenueCollapse[subIndex] && <Button type="text" onClick={() => onSubMenuCollapse(subIndex)} size="small" icon={<DownOutlined />} />}
                                                {subMenueCollapse[subIndex] && <Button type="text" onClick={() => onSubMenuCollapse(subIndex)} size="small" icon={<UpOutlined />} />}
                                              </>}
                                            </Space>
                                          </div>
                                        </div>
                                        {subMenueCollapse[subIndex] && <Droppable droppableId={`sub-sub-${subItem._id}`} type="CHILDSCHILDS">
                                          {(subProvided) => (
                                            <div
                                              ref={subProvided.innerRef}
                                              {...subProvided.droppableProps}
                                            >
                                              {subItem.list?.map((subSubItem, subSubIndex) => (
                                                <Draggable key={subSubItem._id} draggableId={subSubItem._id} index={subSubIndex}>
                                                  {(subProvided) => (
                                                    <div
                                                      ref={subProvided.innerRef}
                                                      {...subProvided.draggableProps}
                                                      {...subProvided.dragHandleProps}
                                                      style={{
                                                        ...subProvided.draggableProps.style,
                                                      }}
                                                      className={selectedItem?._id == subSubItem._id ? "draggable-item padding-left-40 active-item-class" : "draggable-item padding-left-40"}
                                                      onClick={() => {
                                                        setSelectedItem(subSubItem)
                                                      }}
                                                    >
                                                      <div
                                                        style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                                                      >
                                                        {listHeading(subSubItem?.icon, subSubItem, subSubIndex, index, subIndex)}
                                                        {DropDownView(subSubItem, subSubIndex, index, subIndex)}
                                                      </div>
                                                    </div>
                                                  )}
                                                </Draggable>
                                              ))}
                                              {subProvided.placeholder}
                                            </div>
                                          )}
                                        </Droppable>}
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                                {subProvided.placeholder}
                              </div>
                            )}
                          </Droppable>}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Card>
      </Col>
      <Col span={18}>
        {selectedItem && React.cloneElement(<RoutingTabs mainMenu={selectedItem} />)}
      </Col>
    </Row >
  );
};

const mapStateToProps = (state: any) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(Routing);
